import React from "react";
import { Box, Typography, CircularProgress, IconButton } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import { ButtonGroup } from "@mui/material";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import {
  DataGrid,
  GridToolbar,
  GridRowParams, 
  GridActionsCellItem
} from "@mui/x-data-grid";
import { useFormik } from "formik";
import * as Yup from "yup";
import AuthContext from "../auth/AuthProvider";
import { api } from "../api";
import DeleteIcon from '@mui/icons-material/Delete';
import { fetchToken } from "../auth/Token";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import { FormatedDate } from "../components/SavingsDetails";
import TransactionDetailsBnK from "../components/TransactionDetailsBnK";
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import { toast } from 'sonner';


export default function MomoAccountComponent(props) { 
  const [account, setAccount] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [saveOpen, setSaveOpen] = useState(false);
  const [withOpen, setWithOpen] = useState(false);
  const [traOpen, setTraOpen] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const { permissions } = useContext(AuthContext);
  const [start_date, setStart_date] = useState('')
  const [end_date, setEnd_date] = useState('')
  const [tt, settt] = useState()

  const fetchBnK = () => {
    api.get(`/association/transfer/banks/${props.association_id}`, {
      headers: {
          Authorization: "Bearer " + fetchToken(),
      },
    }).then(function (response) {
          setBankAccounts(response.data);
    }).catch(function (error) {
      console.log(error);
    });
 };
  const [total_dep, setTotal_dep] = useState(); 
  const [total_with, setTotal_with] = useState(); 

    const fetchTrs = () => { 
      const florida = new FormData()
      florida.append('association_id', props.association_id)
      florida.append('start_date', start_date)
      florida.append('end_date', end_date)
        api
            .post('/association/momo/transactions', florida, {
            headers: {
                Authorization: "Bearer " + fetchToken(),
            },
            })
            .then(function (response) {
                setTransactions(response.data?.Trs);
                setAccount(response.data?.Acc)
                settt(response.data?.tt)
                setTotal_dep(response.data?.total_dep);
                setTotal_with(response.data?.total_with);
            })
            .catch(function (error) {
            console.log(error);
            });
    };

    const fetchTrsOut = () => {
      api
          .get(`/association/momo/transactions/one/${props.association_id}` , {
          headers: {
              Authorization: "Bearer " + fetchToken(),
          },
          })
          .then(function (response) {
              setTransactions(response.data?.Trs);
              setAccount(response.data?.Acc)
              settt(response.data?.tt)
              setStart_date()
              setEnd_date()
          })
          .catch(function (error) {
          console.log(error);
          });
    };


  useEffect(() => {
    fetchTrs();
    fetchBnK();
  }, []);

//   console.log(transactions)
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    marginBottom: '100px',
    color: theme.palette.text.secondary,
  }));

  const handleDeposit = () => {
    setSaveOpen(true);
  };

  const handleWithdraw = () => {
    setWithOpen(true);
  };

  const handleTransfer = () => {
    setTraOpen(true);
  };

  const closeTransfer = () => {
    formikkk.handleReset();
    setTraOpen(false);
  };

  const closeWithdraw = () => {
    formikk.handleReset();
    setWithOpen(false);
  };

const [loading, setLoading] = useState(false);

  const closeDeposit = () => {
    formik.handleReset();
    setLoading(false);
    fetchTrs()
    setSaveOpen(false);
  };

  const formik = useFormik({
    initialValues: {
        transaction_type: 1,
        amount: null,
        narration: "",
        association_id: props.association_id,
        to_account_id: null,
        date: dayjs()
    },
    validationSchema: Yup.object({
      amount: Yup.number().required("Specify Amount To deposit").min(0),
      narration: Yup.string("Must be characters")
    }),
    onSubmit: (values) => {
        setLoading(true)
        toast.promise(
          api.post("/association/momo/account", values, {
            headers: {
              Authorization: "Bearer " + fetchToken(),
            },
          }),
          {
            loading: 'Loading...',
            success: (res) => {
              props.cashFlow();
              formik.handleReset();
              closeDeposit();
              fetchTrs();
              setLoading(false)
              return res.data
            },
            error: (err) => {
              console.log(error);
              setLoading(false)
              return "An Error occurred"
            }
          }
        )
    },
  });

  const formikk = useFormik({
    initialValues: {
        transaction_type: 2,
        amount: null,
        narration: "",
        to_account_id: null,
        association_id: props.association_id,
        date: dayjs('')
    },
    validationSchema: Yup.object({
      amount: Yup.number().required("Specify Amount To Withdraw").min(0).max(tt?.balance),
      narration: Yup.string("Must be characters"),
      date: Yup.string().required()
    }),
    onSubmit: (values) => {
        setLoading(true)
      api
        .post("/association/momo/account", values, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          props.cashFlow();
          formikk.handleReset();
          closeDeposit();
          fetchTrs();
        })
        .catch(function (error) {
          console.log(error);
        }).finally(function (response){
            setLoading(false);
            fetchTrs();
        });
    },
  });

  const formikkk = useFormik({
    initialValues: {
      transaction_type: 200000000,
      to_account_id: null,
      amount: null,
      narration: "",
      association_id: props.association_id,
      date: dayjs('')
    },
    validationSchema: Yup.object({
      amount: Yup.number().required("Specify Amount To Transfer").min(0),
      date: Yup.string().required()
    }),
    onSubmit: (values) => {
        setLoading(true)
      api
        .post("/association/momo/account", values, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
          },
        })
        .then(function (response) {
          toast.success(response.data);
          props.cashFlow();
          formikk.handleReset();
          closeDeposit();
          fetchTrs();
        })
        .catch(function (error) {
          console.log(error);
        }).finally(function (response){
            setLoading(false);
            fetchTrs();
            props.cashFlow();
        });
    },
  });

const association_id = props.association_id

function formatDateToYearMonthDay(date) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  let suffix = "th";

  if (day === 1 || day === 21 || day === 31) {
    suffix = "st";
  } else if (day === 2 || day === 22) {
    suffix = "nd";
  } else if (day === 3 || day === 23) {
    suffix = "rd";
  }

  return `${day}${suffix} ${month} ${year}`;
}

  const columns = [
    {
      field: "transaction_date",
      headerName: "DateTime",
      flex: 1,
      cellClassName: "name-column--cell",
      renderCell: (params) => formatDateToYearMonthDay(new Date(params.row.transaction_date))
    },
    {
      field: "narration",
      headerName: "Narration",
      flex: 1,
      width: 70,
      editable: true,
    },
    {
      field: "debit",
      headerName: "Debit(GHS)",
      flex: 1,
      width: 70,
      renderCell: (params) =>(
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.transaction_type === 2 ? params.row.amount : 0)}</b></Typography>
      )
    },
    {
      field: "credit",
      headerName: "Credit(GHS)",
      flex: 1,
      width: 70,
      renderCell: (params) =>(
        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.transaction_type === 1 ? params.row.amount : 0)}</b></Typography>
      )
    },
    {
      field: "balance",
      headerName: "Account Balance",
      flex: 1,
      width: 70,
      editable: true,
      renderCell: (params) => (<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.balance)}</b></Typography>)
    },
    {
      field: "transaction_id",
      headerName: "Id",
      flex: 1, 
      width: 70,
    },
    {
      field: "transaction_type",
      headerName: "Type",
      flex: 1,
      width: 70,
      editable: true,
    },
    {
      field: "amount",
      headerName: "Amount(GH₵)",
      flex: 1,
      width: 70,
      editable: true,
      renderCell: (params) => (<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{currencyFormat.format(params.row.amount)}</b></Typography>)
    },
    {
      field: "username",
      headerName: "Prepared by",
      flex: 1,
      width: 70,
    },
    {
        field: "update",
        type:'action', 
        headerName: "Action",
        // flex: 1,
        width:20,
        renderCell: (params) => <TransactionDetailsBnK {...{params, fetchTrs, fetchBnK,association_id }} />
    },
    {
        field: 'delete',
        type: 'actions',
        width:20,
        getActions: (params: GridRowParams) => [
        <GridActionsCellItem
        icon={<DeleteIcon />}
        onClick={() => handleClickOpen(params.row.transaction_id)} 
        label="Open"
        />,]
    },
  ];
  const [openn, setOpenn] = useState(false);
  const [messagee, setMessagee] = useState(false);

  const handleClickOpen = (id) => {
    setOpenn(true)
    setMessagee(id)
  }

  const closeDel = () => {
    setOpenn()
    setMessagee()
  }

  const handleDelete = () =>{
    const id = messagee
    try {
        api.delete(`/association/delete/transaction/${id}`,{
         headers :{
           Authorization: 'Bearer '+ fetchToken()
         }
       }).then(function (response){
            toast.success(response.data)
            setOpenn(false)
            fetchTrs();
            fetchBnK();
            props.cashFlow()
       }).catch(function (error){
            console.log(error)
       })
     } 
     catch(error){
     console.log('This is that error', error )
   };
  }

  const CustomFooterRow = () => {
    return (
      <div>
        <div style={{ display: 'flex', padding: '4px' }}>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h5" sx={{ color:'red', mr:4 }}>Total:</Typography>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h5" sx={{ color:'darkblue', mr:4 }}>Debit: {total_with} </Typography>
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h5" sx={{ color:'darkblue', mr:4 }}>Credit: {total_dep} </Typography>
         </div>
      </div>
    );
  };
  const currencyFormat = new Intl.NumberFormat('en-GH', {
    style: 'currency',
    currency: 'GHS',
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <div>
      <Typography>Filter Date</Typography>
            <div style={{ display:'flex' }}>
              <TextField
                type='date'
                size="small"
                required
                variant="outlined"
                helperText="From"
                name="start_date"
                onChange={(e) => setStart_date(e.target.value)}
                value={start_date}
                sx={{ mr:1 }}
              />

              <TextField
                type='date'
                size="small"
                required
                variant="outlined"
                helperText="To"
                name="end_date"
                onChange={(e) => setEnd_date(e.target.value)}
                value={end_date}
                sx={{ mr:1 }}
              />

              <IconButton onClick={fetchTrs}><FilterAltOutlinedIcon /></IconButton>
              <IconButton onClick={fetchTrsOut}><CancelIcon /></IconButton>
              
            </div>
      <Item>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
            Current balance: <b>{currencyFormat.format(tt?.balance?tt?.balance:0)}</b>
          </Typography>
          <Typography
            variant="h4"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
            sx={{ fontWeight: "700", color: "darkblue" }}
          >
            Savings Group's E-Cash Account
          </Typography>
          {/* <Typography>Open date: {open_date}</Typography> */}
        </Box>

        <Box
          sx={{
            display: "flex-end",
          }}
        >
            <ButtonGroup
              variant="contained"
              aria-label="outlined primary button group"
            >
              <Button fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" onClick={handleDeposit}>Deposit</Button>
              {/* <Button onClick={handleWithdraw} disabled={account?.current_balance <= 0 ? true : false}>Withdraw</Button>
              <Button onClick={handleTransfer} disabled={account?.current_balance <= 0 ? true : false}>Transfer</Button> */}
            </ButtonGroup>
        </Box>
            <>
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h3" sx={{ marginBottom: "10px" }}>
                All Transactions
              </Typography>
              
              <DataGrid
                rows={transactions}
                columns={columns}
                checkboxSelection
                autoHeight
                getRowId={(row) => row.transaction_id}
                slots={{ toolbar: GridToolbar }}
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      transaction_id: false,
                      amount: false,
                      username: false,
                      transaction_type: false,
                    },
                  },
                }}
              />
              <div>
                <div style={{ display: 'flex', padding: '4px' }}>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h5" sx={{ color:'red', mr:4 }}>Total:</Typography>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h5" sx={{ color:'darkblue', mr:4 }}>Debit: {total_with} </Typography>
                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant="h5" sx={{ color:'darkblue', mr:4 }}>Credit: {total_dep} </Typography>
                </div>
              </div>
            </>
      </Item>

      {/* Delete Transaction */}
            <Dialog
                open={openn}
                onClose={closeDel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
            <DialogTitle id="alert-dialog-title">
            {"Delete Transaction"}
            </DialogTitle>
            <DialogContent>
            <DialogContentText id="alert-dialog-description">
                This action cannot be undone. NB: this will not affect the
                current balance of the account.
                Do you wish to continue?
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={closeDel}>Cancel</Button>
            <Button onClick={handleDelete} autoFocus>
                Continue
            </Button>
            </DialogActions>
        </Dialog>

      {/* Deposit */}
      <Dialog open={saveOpen} onClose={closeDeposit}>
        <form onSubmit={formik.handleSubmit}>
          <DialogTitle>Transaction</DialogTitle>
          <DialogContent>
            <DialogContentText>Deposit</DialogContentText>
            <TextField
              margin="dense"
              id="amount"
              name="amount"
              label="Amount (GHS)"
              onChange={formik.handleChange}
              value={formik.values.amount}
              onBlur={formik.handleBlur}
              error={formik.touched.amount && Boolean(formik.errors.amount)}
              helperText={formik.touched.amount && formik.errors.amount}
              type="number"
              fullWidth
              variant="outlined"
            />
            <TextField
              margin="dense"
              id="narration"
              name="narration"
              label="Narration (optional)"
              onChange={formik.handleChange}
              type="text"
              value={formik.values.narration}
              onBlur={formik.handleBlur}
              error={
                formik.touched.narration && Boolean(formik.errors.narration)
              }
              helperText={formik.touched.narration && formik.errors.narration}
              fullWidth
              variant="outlined"
            />

            <DateTimePicker
                id="date"
                name="date"
                label="Set date of transaction"
                value={formik.values.date}
                onChange={(date) => formik.setFieldValue('date', date)}
                orientation="landscape"
            />

          </DialogContent>
          <DialogActions>
          <Button size='small' variant='contained' sx={{ backgroundColor:"#78290f", color: '#fff' }} onClick={closeDeposit}>Cancel</Button>
            <Button
                type='submit'
                size='small'
                variant='contained'
                sx={{ backgroundColor:"#80ffdb", color: '#000' }}
            >
                { loading === true ? 
                    <Box sx={{ width: '100%' }}>
                    <CircularProgress />
                </Box>
                :
                "Deposit"
                }
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* withdrawal */}

      <Dialog open={withOpen} onClose={closeWithdraw}>
        <form onSubmit={formikk.handleSubmit}>
          <DialogTitle>Transaction</DialogTitle>
          <DialogContent>
            <DialogContentText>Withdraw</DialogContentText>
            <TextField
              margin="dense"
              id="amount"
              name="amount"
              label="Amount to withdraw"
              onChange={formikk.handleChange}
              value={formikk.values.amount}
              onBlur={formikk.handleBlur}
              error={formikk.touched.amount && Boolean(formikk.errors.amount)}
              helperText={formikk.touched.amount && formikk.errors.amount}
              type="number"
              fullWidth
              variant="outlined"
            />

            <TextField
              margin="dense"
              id="narration"
              name="narration"
              label="Narration (optional)"
              onChange={formikk.handleChange}
              type="text"
              value={formikk.values.narration}
              onBlur={formikk.handleBlur}
              error={
                formikk.touched.narration && Boolean(formikk.errors.narration)
              }
              helperText={formikk.touched.narration && formikk.errors.narration}
              fullWidth
              variant="outlined"
            />

            <DateTimePicker
                id="date"
                name="date"
                label="Set date of transaction"
                value={formikk.values.date}
                onChange={(date) => formikk.setFieldValue('date', date)}
                orientation="landscape"
            />

          </DialogContent>
          <DialogActions>
          <Button onClick={closeWithdraw}>Cancel</Button>
            <Button
                type='submit'
            >
                { loading === true ? 
                    <Box sx={{ width: '100%' }}>
                    <CircularProgress />
                </Box>
                :
                "Withdraw"
                }
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      {/* Transfer */}

      <Dialog open={traOpen} onClose={closeTransfer}>
        <form onSubmit={formikkk.handleSubmit}>
          <DialogTitle>Transaction</DialogTitle>
          <DialogContent>
            <DialogContentText>Transfer</DialogContentText>
            <Select
              required
              variant="outlined"
              id="to_account_id"
              label="Bank Account Transfer To"
              value={formikkk.values.to_account_id}
              onChange={formikkk.handleChange}
              fullWidth
              onBlur={formikkk.handleBlur}
              error={
                formikkk.touched.to_account_id &&
                Boolean(formikkk.errors.to_account_id)
              }
              helperText={
                formikkk.touched.to_account_id && formikkk.errors.to_account_id
              }
              name="to_account_id"
            >
              {bankAccounts.map((account) => (
                <MenuItem value={account.id} key={account.id}>
                  {account.account_name}
                </MenuItem>
              ))}
            </Select>

            <TextField
              margin="dense"
              id="amount"
              name="amount"
              label="Amount"
              onChange={formikkk.handleChange}
              type="text"
              value={formikkk.values.amount}
              onBlur={formikkk.handleBlur}
              error={formikkk.touched.amount && Boolean(formikkk.errors.amount)}
              helperText={formikkk.touched.amount && formikkk.errors.amount}
              fullWidth
              variant="outlined"
            />

            <DateTimePicker
                id="date"
                label="Set date of transaction"
                name="date" 
                value={formikkk.values.date}
                onChange={(date) => formikkk.setFieldValue('date', date)}
                orientation="landscape"
            />

          </DialogContent>
          <DialogActions>
          <Button
                size='small'
                onClick={closeTransfer}
                color='error'
                variant='contained'
                sx={{ mt:1, mr:1 }}
            >
                Cancel
            </Button>
            <Button
                variant='contained'
                type='submit'
                color='success'
                size='small'
                sx={{ mt:1 }}
            >
                {
                    loading === true ?
                    <Box sx={{ width: '100%' }}>
                        <CircularProgress />
                    </Box>
                    : "Transfer"
                }
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
    </LocalizationProvider>
  );
}
